import { UntypedFormControl } from '@angular/forms';
import { of } from 'rxjs';
import { UserValidationUtilES } from './es-user-validation.util';

export type DocumentType = 'DNI' | 'NIE' | 'BOTH';

export class CustomValidators {
  /**
   * Method that check if user dni/nie is valid
   * @param formControl
   */
  public static validateDocument(documentType: DocumentType) {
    return (formControl: UntypedFormControl) => {
      const userFormControl = formControl.value ? formControl.value.toUpperCase() : '';
      let isValid = false;
      switch (documentType) {
        case 'DNI':
          isValid = UserValidationUtilES.validateDNI(userFormControl);
          break;
        case 'NIE':
          isValid = UserValidationUtilES.validateNIE(userFormControl);
          break;
        case 'BOTH':
          {
            isValid = UserValidationUtilES.validateDNI(userFormControl)
              ? true
              : UserValidationUtilES.validateNIE(userFormControl);
          }
          break;
      }
      return of(
        isValid
          ? null
          : {
              validateDocument: true,
            },
      );
    };
  }
}
